import { GqlClientService } from '@/common/network/gql-client-service'
import * as op from '@/common/errors/OperationResult'
import type { OperationResult } from '@/common/errors/OperationResult'
import type { SearchInput, SearchResult } from '@/generated/graphql'

type SearchResponse = { search: SearchResult[] }

export class SearchApiService {
  constructor(private readonly gqlClientService: GqlClientService) {}

  async search(input: SearchInput): Promise<OperationResult<SearchResult[]>> {
    const query = `query($input: SearchInput!) {
  search(input: $input) {
    score
    object { id typeId name description }
    collection { id name }
  }
}`
    const res = await this.gqlClientService.sendGqlRequest<SearchResponse>(query, {
      variables: { input },
    })
    if (res.isError()) return op.error(res.error)
    return op.success(res.result!.data!.search)
  }
}
